import { Config } from 'olympe';
import BCP from './DM_BCP';
import { getNotAvailableText, getTargetBCPText } from '../../web/section_sf/Utils';
import { getCurrentVendorSite } from '../utils/CommonUtil.js'

/* common utils */
export const parseNameEmail = (value) => {
  if (!value) return null; // Handle missing values gracefully
  const [name, email] = value.split(';').map((item) => item.trim());
  if (!name || !email) return null; // Ensure both name and email are valid
  return { name, email };
};

/**
 * @param {!Array<*>} list
 * @return {!Array<*>}
 */
export function uniqueListByProperty(list, property) {
  return Array.from(new Map(list.map((item) => [item[{ property }], item])).values());
}

export const generateEmailContents = async (emailData, $) => {
  const EnvironmentMap = {
    dev: 'https://ensuring-supply-codev.olympe.io/#app=RC;tab=3',
    preprod: 'https://ensuring-supply-preprod.olympe.io/#app=RC;tab=3',
    prod: 'https://ensuring-supply.olympe.io/#app=RC;tab=3',
  };
  const webAppUrl = EnvironmentMap[Config.getParameter('ENV')] || '';
  const docLink = Config.getParameter('qrcAcceptRejectExplanationLink');

  let bcpobjects = emailData.bcpobjects;
  let user = parseNameEmail(emailData.mailto);
  let emailContent = `
    <p>Dear ${user.name},</p>
    <p>This is a weekly reminder of BCP request(s) that are pending evaluation. Please review & evaluate the requests. Once evaluation is done, please accept or reject requests via the Ensuring Supply Webapp.</p>
    <p>To accept/reject a BCP request, please click on this <a href="${webAppUrl}">link</a> to go to the Ensuring Supply WebApp and go to the “Manage BCP Request” tab. To understand how to accept/reject a BCP requests, please click on this <a href="${docLink}">link</a></p>
    <b>Following BCP request(s) waiting for your input:</b>
    <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;">
      <thead>
        <tr>
            <th>Plant</th>
            <th>Material-Description</th>
            <th>Specification</th>
            <th>Main Vendor-Description</th>
            <th>Current Vendor Site-Description</th>
            <th>Requestor</th>
            <th>Request Date</th>
            <th>Alternative site to be developed</th>
            <th>Target BCP</th>
            <th>Priority</th>
            <th>Cost savings</th>
            <th>Estimated Savings in CHF</th>
       </tr>
      </thead>
      <tbody>`;

  //added optional chaining to prevent null pointer errors
  // bcpobjects?.forEach(async bCPRequest => {
  for (let i = 0; i < bcpobjects?.length; i++) {
    // Find the recent event that matches the event_id
    let bCPRequest = bcpobjects[i]
    // let currentVendorSiteAndDescription = await returnCurrentVendorSite(bCPRequest, $)
    let options = {
      year: "numeric",
      month: "short",
      day: "numeric"
    };
    let currentVendorSiteAndDescription;
    if (!bCPRequest.get(BCP.currentVendorSiteIdProp)) {
      currentVendorSiteAndDescription = await getCurrentVendorSite(bCPRequest, $)
    } else {
      currentVendorSiteAndDescription = bCPRequest.get(BCP.currentVendorSiteIdProp) + ":" + bCPRequest.get(BCP.currentVendorSiteDescriptionProp)
    }
    emailContent += `
                <tr>
                    <td style="text-align: center;">${bCPRequest.get(BCP.plantIdProp) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${(bCPRequest.get(BCP.materialIdProp) + " - " + (bCPRequest.get(BCP.materialDescriptionProp) || getNotAvailableText())) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${bCPRequest.get(BCP.specificationProp) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${bCPRequest.get(BCP.mainVendorIdProp) || getNotAvailableText() + " - " + bCPRequest.get(BCP.mainVendorDescriptionProp) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${currentVendorSiteAndDescription}</td>
                    <td style="text-align: center;">${bCPRequest.get(BCP.requestorProp) || getNotAvailableText()}</td>                   
                    <td style="text-align: center;">${new Date(bCPRequest.get(BCP.requestDateProp)).toLocaleDateString("en-US", options) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${bCPRequest.get(BCP.alternativeVendorCodeProp) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${getTargetBCPText(bCPRequest.get(BCP.targetBCPProp)) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${bCPRequest.get(BCP.priorityProp) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${bCPRequest.get(BCP.costSavingsProp) || getNotAvailableText()}</td>
                    <td style="text-align: center;">${bCPRequest.get(BCP.inputSavingEstimatesProp) || getNotAvailableText()}</td>
                  </tr>`;

  }

  emailContent += `
      </tbody>
    </table>
    <p>Please do not reply to this email as this is an automatically generated notification</p>
    <p>Thank you for your collaboration.</p>
    <p>Your Ensuring Supply Team</p>`;

  return emailContent;
};
